/* eslint-disable new-cap */
import { PostParams, PostsEndpoints, PostsService } from 'src/services/posts'

import { ROWS_POST_PER_PAGE } from 'src/utils/constants'
import { useInfiniteRequest } from '../useInfinityRequest'

export const useGetInfinityScheduledPosts = (params: Omit<PostParams, 'page'>) =>
  useInfiniteRequest(
    [PostsEndpoints.getSchedulePosts(params.id)],
    async ({ pageParam = 0 }) =>
      (await PostsService.getScheduledPosts({ ...params, page: pageParam }))?.news,
    {
      getNextPageParam: (lastPage) => {
        const rows = params.rows ?? ROWS_POST_PER_PAGE

        if (lastPage?.page < Math.ceil(lastPage?.size / rows) - 1) {
          return lastPage?.page + 1
        }

        return undefined
      },
      cacheTime: 0
    }
  )
